import { Fragment, PureComponent, createRef } from 'react';
import { isNull, isUndefined, isArray } from 'lodash-es';
import { Link, withRouter } from 'react-router-dom';
import { getMeta } from 'constants/meta';
import Form from 'components/Form';
import Button from 'components/Button';
import Head from 'components/Head';
import { InputHasPasswordToggleErrorIcon } from 'components/Input/InputVariants';
import { apiPasswordRecovery } from 'constants/api';
import { to } from 'helpers';

import LoginHeader from './LoginHeader';

const RESET_PROPS = {
  title: 'Reset Password',
};

class NewPasswordForm extends PureComponent {
  constructor(props) {
    super(props);

    const param = '?passwordResetToken=';

    this.token = props.location.search.slice(param.length);

    if (!this.token) {
      props.history.replace('/login/recovery');
    }
  }

  passRef = createRef();

  confirmRef = createRef();

  handleValidatePassword = async ({
    errors,
    values,
    validate,
    toggleSubmitting,
  }) => {
    const { password, confirmPassword } = values;

    if (errors.password) {
      validate('password', errors.password);
      toggleSubmitting(false);
      return;
    }

    if (password !== confirmPassword) {
      validate('confirmPassword', 'Passwords do not match.');
      toggleSubmitting(false);
      return;
    }

    const [err, data] = await to(
      apiPasswordRecovery.confirm({
        password: values.password,
        token: this.token,
      })
    );

    if (!isNull(err)) {
      if (isUndefined(err.response)) {
        validate(
          'submitErrors',
          'Network connection is temporary unavailable. Please try again.'
        );
        return toggleSubmitting(false);
      }

      if (!err.response.data) {
        return toggleSubmitting(false);
      }

      const { message } = err.response.data;

      if (!isArray(message)) {
        validate('submitErrors', 'User with provided token is not found.');
      } else {
        message.forEach(({ field, message }) => {
          validate(`${field}`, message);
        });
      }

      toggleSubmitting(false);
      return;
    }

    const {
      data: { redirectUrl },
    } = data;
    window.location.replace(redirectUrl);
  };

  render() {
    const { location } = this.props;
    const { title, description } = getMeta(location.pathname);
    return (
      <Fragment>
        <Head title={title} description={description} />
        <LoginHeader {...RESET_PROPS} />
        <Form
          className="login__form _mb-37"
          initialValues={{ password: '', confirmPassword: '' }}
          onValidate={this.handleValidatePassword}
        >
          {({ errors, submitting, onChange, values }) => (
            <Fragment>
              <div className="login__form-row _mb-20">
                <InputHasPasswordToggleErrorIcon
                  className="login__input login__input_password input_password"
                  name="password"
                  placeholder="Password"
                  icon="password"
                  value={values.password}
                  iconClassName="login__input-holder"
                  buttonClassName="btn input__password-switch"
                  error={errors.password || errors.submitErrors}
                  onChange={onChange}
                  innerRef={this.passRef}
                  tabIndex="1"
                  btnTabIndex="0"
                />
              </div>
              <div className="login__form-row _mb-20">
                <InputHasPasswordToggleErrorIcon
                  className="login__input login__input_password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={values.confirmPassword}
                  icon="password"
                  buttonClassName="btn input__password-switch"
                  iconClassName="login__input-holder"
                  error={errors.confirmPassword}
                  onChange={onChange}
                  innerRef={this.confirmRef}
                  tabIndex="1"
                  btnTabIndex="0"
                />
              </div>
              <div className="login__form-row">
                <Button
                  className="btn_brand login__btn"
                  submitting={submitting}
                  tabIndex="1"
                >
                  Confirm New Password
                </Button>
              </div>
            </Fragment>
          )}
        </Form>
        <div className="text login__subtitle _mb-10">
          Remember your password?
        </div>
        <div className="login__link-wrap _mb-60">
          <Link to="/login" className="link login__link">
            Back to Login
          </Link>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(NewPasswordForm);
